import { createContext } from 'react';
import type { ModalControls } from './modalTypes';

// Without a provider there is nowhere to show a modal, so opening one does nothing.
const NO_MODAL_PROVIDER: ModalControls = {
  openModal: () => {},
  closeModal: () => {},
};

/**
 * Shared by ModalProviderComponent, which supplies it, and useModal, which reads it. It holds no
 * modal components, so the hook never imports the components it opens.
 */
export const ModalContext = createContext<ModalControls>(NO_MODAL_PROVIDER);
